<template>
  <section
    class="section faq"
    :class="{
      '-light': bg_color === 'light',
      '-dark': bg_color === 'dark',
      '-blue': bg_color === 'blue',
    }"
  >
    <h2 class="section__title faq__title" v-reveal>{{ title }}</h2>
    <div class="faq__content">
      <div class="faq__question" v-for="question in questions" :key="question.flexKey" v-reveal>
        <p class="faq__question--title">{{ question.question }}</p>
        <p class="faq__question--answer">{{ question.answer }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionFaq',
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    bg_color: {
      type: String,
      default: 'light',
    },
    questions: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
